'use client';

import { useModalStore } from '../../store/modal.store';
import { modalRegistry } from './modal-registry';

/**
 * Container component that renders all active modals
 * Should be placed at the root level of the app
 *
 * @example
 * // In app layout
 * <body>
 *   <main>{children}</main>
 *   <ModalContainer />
 * </body>
 */
export function ModalContainer() {
  const modals = useModalStore((state) => state.modals);
  const closeModal = useModalStore((state) => state.closeModal);

  return (
    <>
      {modals.map((modalState) => {
        const registryEntry = modalRegistry.find((entry) => entry.id === modalState.id);

        if (!registryEntry) {
          console.warn(`Modal with id "${modalState.id}" is not registered`);
          return null;
        }

        const ModalComponent = registryEntry.component;

        return (
          <ModalComponent
            key={modalState.id}
            isOpen={modalState.isOpen}
            onClose={() => closeModal(modalState.id)}
            {...(modalState.props || {})}
          />
        );
      })}
    </>
  );
}
